const DirectionX = [
    {
        name: '左对左',
        calc: (compare) => ({
            lineLeft: compare.x,
            triggerLeft: compare.x
        })
    },
    {
        name: '左对右',
        calc: (compare) => ({
            lineLeft: compare.x + compare.width,
            triggerLeft: compare.x + compare.width
        })
    },
    {
        name: '中对中',
        calc: (compare, target) => ({
            lineLeft: compare.x + compare.width / 2,
            triggerLeft: compare.x + compare.width / 2 - target.width / 2
        })
    },
    {
        name: '右对右',
        calc: (compare, target) => ({
            lineLeft: compare.x + compare.width,
            triggerLeft: compare.x + compare.width - target.width
        })
    },
    {
        name: '右对左',
        calc: (compare, target) => ({
            lineLeft: compare.x,
            triggerLeft: compare.x - target.width
        })
    },
]
const DirectionY = [
    {
        name: '顶对顶',
        calc: (compare) => ({
            lineTop: compare.y,
            triggerTop: compare.y
        })
    },
    {
        name: '底对顶',
        calc: (compare, target) => ({
            lineTop: compare.y,
            triggerTop: compare.y - target.height
        })
    },
    {
        name: '中对中',
        calc: (compare, target) => ({
            lineTop: compare.y + compare.height / 2,
            triggerTop: compare.y + compare.height / 2 - target.height / 2
        })
    },
    {
        name: '顶对底',
        calc: (compare) => ({
            lineTop: compare.y + compare.height,
            triggerTop: compare.y + compare.height
        })
    },
    {
        name: '底对底',
        calc: (compare, target) => ({
            lineTop: compare.y + compare.height,
            triggerTop: compare.y + compare.height - target.height
        })
    }
]



export {
    DirectionX,
    DirectionY
}
